class VueSignals {
    constructor(){
        this.CONNECT_SUCCESS = "CONNECT_SUCCESS"
        this.CONNECTION_LOST = "ConnLost"
        this.LOADED_MENTIONS = "loaded_mentions"
        this.DRAFT_IS_THERE =  "draft_is_there"
        this.ACTIVE_CHANNEL_CHANGED_SIGNAL = "active_channel_changed"
        this.ACTIVE_CHANNEL_CHANGED_SIGNAL_NAME = "active_channel_name_changed"
        this.ACTIVE_POSSIBLE_CHANGED = "active_possible_changed"
        this.CHANNEL_CONTENT_CHANGED = "channel_content_changed"
        this.ACTIVE_CHANNEL_PARENT_DOCS = "active_channel_parent_docs"
        this.LOGGED_IN_USER = "loggedInUser"
        this.HIDE_CONTEXT_MENU = "hide_context_menu"
        this.MOVE_CONTEXT_MENU = "move_context_menu"
        this.HIDE_OPTIONS_MENU = "hide_options_menu"
        this.CHANNEL_LIST_CHANGED = "channel_list_changed"
        this.ALL_MESSAGES_SEEN = "all_messages_seen"
        this.NOTIFICATION_NEED_PERMISSION = "notification_need_permission"
        this.REMOVE_CHANNEL = "remove_channel"
        this.LOADED_CHANNEL_ID = "load_channel_id"
        this.OVERLAY_TYPE = "overlay_type"
        this.SHOW_MODAL = "showModal"
        this.SHOW_SMALL_MODAL = "showSmallModal"
        this.SHOW_SMALL_MODAL_TYPE = "showSmallType"
        this.SMALL_OVERLAY_DATA = "small_overlay_data"
        this.USER_CHANNEL_RIGHTS = "user_channel_rights"
        this.RIGHT_SIDEBAR_COLLAPSED = "right_sidebar_collapsed"
        this.RIGHT_SIDEBAR_THEME= "right_sidebar_theme"
        this.IS_LOGGEDIN_USER = "loggedIn"
        this.SESSION_ID = "sessionId"
        this.AUTHENTICATED = "authenticated"
        this.CHANNEL_DETAILS_OVERRIDED = "channel_details_overrided"
        this.EVENT_USER_CHANGED = "event_user_changed"
        this.CHANNEL_USERS_CHANGED = "channel_users_changed"
        this.CHANNEL_USERS_ACCEPTED_INVITATION = "CHANNEL_USERS_ACCEPTED_INVITATION"
        this.SHOW_USER_DETAILS = "show_user_details"
        this.CLOSE_OPTIONS_MENU = "closeOptionsMenu" // channel_settings
        this.SHOW_MENTION_DETAILS = "show_mention_details"
        this.ACTIVATED_VIEW = "activated_view"
        this.SHOW_LEFT_SIDEBAR_MOBILE = "showLeftSidebarMobile"
        this.SHOW_RIGHT_SIDEBAR_MOBILE = "showRightSidebarMobile"
        this.TOOGLE_LEFT_SIDE_BAR_MOBILE = "TOOGLE_LEFT_SIDE_BAR_MOBILE"
        this.TOOGLE_RIGHT_SIDE_BAR = "TOOGLE_RIGHT_SIDE_BAR"
        this.RECONNECT_ATTEMPTS = "reconnect_attempt"
        this.SPLASH_SCREEN = "SplashScreen"
        this.NOTIFICATION_ALLOWED = "notification_allowed"
        this.MESSAGE_CHANGED = "message_changed"
        this.CHANNEL_OPTIONS_HIGHLIGHT = "channel_options_highlight"
        this.CHAT_SPINNER_OFF = "chat_spinner_off"
        this.CHANNEL_USERS_HIGHLIGHT = "channel_user_highlight"
        this.HIDE_KEYBOARD_GENERATED_LIST = "hide_generated_list"
        this.HIDE_EMOJI_LIST = "hide_emoji"
        this.KEYBOARD_CLOSE_MESSAGE_LIST = "close_message_list"
        this.EXTERNAL_USER_JOIN = "external_user_join"
        this.REMOVE_ALL_MENTIONS = "removeAllMentions"
        this.WEBLINK_CREATED = "weblink_created"
        this.SHOW_MENTION_USERS = "show_mention_users"
        this.HIDE_MENTION_USERS = "hide_mention_users"
        this.READ_MESSAGE_IDS = "read_message_ids"
        this.HIDE_KEYBOARD_FOLDER_LIST = "hide_folder_list"
        this.BLOCK_USER_PROFILE_OVERLAY_CLOSE = "block_closing_overlay"
        this.EMPTY_FILE_UPLOAD_MESSAGE_ERROR = "empty_file_message_error"
        this.CLOSE_MESSAGE_AREA_LIST = "global_close_textarea_list"
        this.HIDE_COPPIED_EXTERNAL_LINKS = "hide_copied"
        this.LOADED_MESSAGES_IDS ="load_read_message_ids"
        this.REMOVE_POST_EDIT = "REMOVE_POST_EDIT"

        this.TOOGLE_TEXT_CARET = "TOOGLE_TEXT_CARET"
        this.REMOVE_TEXTAREA_PLACEHOLDER = "REMOVE_TEXTAREA_PLACEHOLDER"

        this.REMOVE_PROGRESS_BAR = "remove_progress_bar"
        this.CROPPING_ZOOM_IN = "cropping_zoom_in"
        this.CROPPING_ZOOM_OUT = "cropping_zoom_out"
        this.CROP_IMAGE_READY = "crop_image_ready"

        this.CLEAR_COPPIED= "clear_copied"

        this.BULK_OPERATION = "add_bulk_op"

        this.REMOVE_ERROR_MESSAGE_RIGHT_SIDEBAR = "remove_error_message"
        this.IS_BULK_OPERATION = "bulk_operation"
        this.FF_RENAME_ERROR_REASON = "ff_rename_error"
        this.DELETE_FF = "deleteFF"
        this.RENAME_FF = "RenameFF"
        this.DELETE_MESSAGE = "DELETE_MESSAGE"
        this.LEAVE_CHANNEL_CONFIRMATION = "leave_confirm"
        this.EDIT_CHANNEL = "editChannel"
        this.EMPTY_FILE_RENAME_REASON_ERROR = "empty_ff_rename_message_error"
        this.DELETE_CHANNEL_CONFIRMATION = "delete_confirm"
        this.REMOVE_CHANNEL_OPTIONS_HIGHLIGHT = "remove_highlight"
        this.REMOVE_CHANNEL_LICENSE = "notification_license_remove"
        this.ADD_CHANNEL_LICENSE = "notification_license_add"
        this.CREATE_FOLDER = "createFolder"
        this.SEARCH_FEED_TEXT = "search_feed_text"
        this.UPLOAD_FILE_MESSAGE_ERROR = "file_message_error"
        this.CLEAR_CREATE_FOLDER_ERROR = "remove_create_folder_error"
        this.EMPTY_FILE_MESSAGE_REASON_SUCCESS = "empty_file_message_success"


        this.CREATE_MENTION_FOLDER = "create_mention_folder"
        this.FOLDER_LIST_CONTENT = "folder_list_content"
        this.KEYBOARD_SHOW_CHANNEL_LIST = "show_channel_list"
        this.MENTION_MENTION_TAG_FF = "mention_match_ff"
        this.MENTION_MENTION_TAG_FF_FEED = "mention_ff_feed"
        this.KEYBOARD_FILTERED_FF = "filterd_ff"

        this.MENTION_FILE = "addFileMention"
        this.TYPING_ACTION = "Typing_Action"
        this.TYPING_ACTION_NOTIFICATION = "userTyping"

        this.CREATE_MENTION_USER = "create_mention_users"
        this.SOCKET_MESSAGE_POSTED = "SOCKET_MESSAGE_POSTED"
        this.KEYBOARD_FILTERED_MENTION_USERS = "filterd_users"
        this.KEYBOARD_NAVIGATE_MENTION_ITEM = "nav_mention_item"
        this.KEYBOARD_CHOOSE_MENTION_ITEM = "choose_mention_item"
        this.KEYBOARD_MENTION_USER_TAG = "mention_match_user"
        this.KEYBOARD_MENTION_USER_TAG_FEED = "mention_user_feed"
        this.REMOVE_BG_INVITED_CHANNEL = "remove_bk_success"
        this.INVITED_CHANNEL_ACCEPTED = "active_channel_invitation_accepted"
        this.UPDATE_UPLOAD_PROGRESS = "upload_progress"
        this.OVERLAY_DATA ="overlay_data"
        this.UPLOAD_FILE = "upload_file"
        this.STOP_SEND_TYPYING_SIGNAL = "stopTyping"
        this.SEND_MESSAGE = "send_message"
        this.SEND_OFFLINE_MESSAGE = "SEND_OFFLINE_MESSAGE"
        this.SOCKET_POST_SEEN= "SOCKET_POST_SEEN"

        this.UPLOAD_PAUSED_ID = "upload_paused_id"
        this.SET_UPLOAD_PAUSED = "set_upload_paused"
        this.SET_UPLOAD_CONTINUE = "set_upload_continue"
        this.SET_UPLOAD_CANCELD = "set_upload_canceld"
        this.UPLOAD_FILE_DATA = "upload_file_data"
        this.UPLOAD_FILE_EDIT_NAME = "editFileName"
        this.UPLOAD_CHANNEL_PICTURE = "UPDATE_CHANNEL_PICTURE"

        this.OPEN_FILE_IN_BROWSER = "openFileInBrowser"
        this.SHOW_EXTERNAL_LINK_FOR = "showExternalLinkFor"

        this.CHANNEL_ID_FROM_CONTACT_LINK = 'contact_channel_id'
        this.USER_ID_FROM_CONTACT_LINK = 'contact_user_id'

        this.CHOOSE_CREATE_CHANNEL = 'CHOOSE_CREATE_CHANNEL'
        this.MEDIA_MODAL = 'MEDIA_MODAL'
        this.CHANNELS_ARRANGE_TOOL = 'CHANNELS_ARRANGE_TOOL'

        this.SET_UP_EDIT_MESSAGE = 'SET_UP_EDIT_MESSAGE'

        // socket Notifications
        this.SOCKET_CHANNEL_CREATE = "SOCKET_CHANNEL_CREATE"
        this.SOCKET_CHANNEL_INVITE = "SOCKET_CHANNEL_INVITE"
        this.SOCKET_CHANNEL_REMOVE_INVITATION = "SOCKET_CHANNEL_REMOVE_INVITATION"
        this.SOCKET_POST_EDITED = "SOCKET_POST_EDITED"
        this.SOCKET_POST_DELETED = "SOCKET_POST_DELETED"
        this.SOCKET_CHANNEL_PURPOSE_EDIT = "SOCKET_CHANNEL_PURPOSE_EDIT"
        this.SOCKET_CHANNEL_DELETED = "SOCKET_CHANNEL_DELETED"
        this.SOCKET_REMOVE_USER_FROM_CHANNEL = "SOCKET_REMOVE_USER_FROM_CHANNEL"

        this.SOCKET_USER_JOIN_CHANNEL = "SOCKET_USER_JOIN_CHANNEL"
        this.SOCKET_USER_LEFT_CHANNEL = "SOCKET_USER_LEFT_CHANNEL"
        this.SOCKET_USER_CREATED = "SOCKET_USER_CREATED"
        this.SOCKET_CHANNEL_RENEAMED = "SOCKET_CHANNEL_RENEAMED"
        this.SOCKET_CHANNEL_CHANGED = "SOCKET_CHANNEL_CHANGED"
        this.SOCKET_CHANNEL_CREATED = "SOCKET_CHANNEL_CREATED"
        this.SOCKET_USER_CHANGED = "SOCKET_USER_CHANGED"
        this.SOCKET_USER_STATUS_CHANGED = "SOCKET_USER_STATUS_CHANGED"
        this.SOCKET_CHANNEL_EDIT = "SOCKET_CHANNEL_EDIT"
        this.SOCKET_REFRESH_UI = "SOCKET_REFRESH_UI"

        //@VARS
        this.DRAFT_CHANNEL_ID = "direct_message_draft_id"


        //@BUS
        this.BUS_LOGGEDIN_ARRIVED = "bus_loggedin_arrived"

        // drag and drop mention
        this.DRAG_DROP_FILE_MENTION = "DRAG_DROP_FILE_MENTION"
        this.DRAG_DROP_USER_MENTION = "DRAG_DROP_USER_MENTION"
    }
}

export default new VueSignals()
